import { useEffect } from 'react';
import { ClientFlags, OnboardingTrialStepsType } from '@sdk/authentication/types';
import type { PersonasDict } from '@sdk/personaCollection/types/PersonasDict';

import isStepCompleted from '../helpers/isStepCompleted';

import type { CompleteStep } from './useCompleteStep';

type Props = {
  availableSteps: OnboardingTrialStepsType[];
  completeStep: CompleteStep;
  clientFlags: ClientFlags;
  personasDict: PersonasDict;
};
const useAutocompleteAddEmployeeStep = ({
  availableSteps,
  completeStep,
  clientFlags,
  personasDict,
}: Props) => {
  useEffect(() => {
    if (!clientFlags) {
      // if we don't have client flags at all we're not ready to mark it completed, waiting for them to load.
      return;
    }

    if (isStepCompleted(clientFlags, OnboardingTrialStepsType.addEmployees)) {
      // step was completed before, no need to proceed further
      return;
    }

    const hasAddedEmployees =
      Object.keys(personasDict).filter((id) => personasDict[id].type === 'user').length > 1;

    if (hasAddedEmployees) {
      completeStep(OnboardingTrialStepsType.addEmployees, availableSteps);
    }
  }, [availableSteps, completeStep, personasDict, clientFlags]);
  return null;
};

export default useAutocompleteAddEmployeeStep;
